module.exports = __webpack_public_path__ + "static/img/logo.bed8a04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 1138
// module chunks = 3 4 5 7 22